import * as API from './index'

export default {
    get: params => {
        return API.GET('/api/UserTeam/Get', params)
    },
    getList: params => {
        return API.GET('/api/UserTeam/List', params)
    },
    select: params => {
        return API.GET('/api/UserTeam/select', params)
    },
    add: params => {
        return API.POST('/api/UserTeam/Add', params)
    },
    edit: params => {
        return API.POST('/api/UserTeam/Edit', params)
    },
    delete: params => {
        return API.DELETE('/api/UserTeam/delete', params)
    },
    deleteBatch: params => {
        return API.DELETEBATCH('/api/UserTeam/DeleteBatch', params)
    },
    enable: params => {
        return API.GET('/api/UserTeam/Enable', params)
    },
    disable: params => {
        return API.GET('/api/UserTeam/Disable', params)
    },
}


// WEBPACK FOOTER //
// ./src/apis/userteam.js